import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

import { Link } from "react-router-dom";
import "../css/App.css";

function App() {
  const { user } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      navigate("/signin");
    }
  }, [user, navigate]);

  if (!user?.email) {
    return null;
  }

  return (
    <div className="container mx-auto text-center">
      <ul>
        <li>
          <Link to="/models/core/cultural">Cultural</Link>
        </li>
      </ul>
    </div>
  );
}

export default App;
